import { render } from "./Aggregation.vue?vue&type=template&id=766ea88a&scoped=true"
import script from "./Aggregation.vue?vue&type=script&lang=js"
export * from "./Aggregation.vue?vue&type=script&lang=js"

import "./Aggregation.vue?vue&type=style&index=0&id=766ea88a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766ea88a"]])

export default __exports__